import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onClick: () => void
  showResumed: boolean
}
export const CollapsableButton = ({ onClick, showResumed }: Props) => {
  return (
    <Box
      paddingTop="s4"
      position="absolute"
      paddingBottom="s16"
      alignItems="center"
      justifyContent="center"
      background="grey000White"
      style={{ bottom: '0', zIndex: '1000' }}
    >
      <Box
        cursor="pointer"
        flexDirection="row"
        gap="s8"
        style={{
          width: 'fit-content',
        }}
        onClick={onClick}
      >
        <Text.Normal size="200" weight="semibold" color="grey1000" underlined>
          {showResumed
            ? i18n.t('finance.financial_workspace.employee_costs.workforce.collapse.up')
            : i18n.t('finance.financial_workspace.employee_costs.workforce.collapse.down')}
        </Text.Normal>
        <Icon.Small color="grey800" icon={showResumed ? 'arrow-down' : 'arrow-up'} />
      </Box>
    </Box>
  )
}
